import React, {useEffect, useState, useCallback} from 'react';
import { Table, Button, Input, Space } from 'antd';
import { SearchOutlined, DownloadOutlined } from '@ant-design/icons';
import Navigate from "../../components/Navigate";
import {serverRequest} from "../../util/server_request";
import {exportToCSV, exportToPDF} from "../../util/util";
import { formatCreatedAt } from "../../util/dateFormatter";

const formatText = (text) => {
  return text ? text.replace(/_/g, ' ') : text;
};
const columns = [
    {
        title: 'Date Created',
        dataIndex: 'createdAt',
        key: 'createdAt',
        render: (text) => formatCreatedAt(text),
    },
    {
        title: 'Year',
        dataIndex: 'year',
        key: 'year',
    },
    {
        title: 'Statement Type',
        dataIndex: 'statementType',
         key: 'statementType',
        render: (text) => formatText(text), 
    },
    // Hidden columns per UI requirement:
    // {
    //     title: 'No of Members',
    //     dataIndex: 'totalReport',
    //     key: 'totalReport',
    // },
    // {
    //     title: 'Successful Report',
    //     dataIndex: 'successfulReport',
    //     key: 'successfulReport',
    // },
    // {
    //     title: 'Failed Report',
    //     dataIndex: 'failedReport',
    //     key: 'failedReport',
    // }
];

const CompanyStatementTable = () => {

    const [data, setData] = useState([]);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });
    const [loading, setLoading] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [originalData, setOriginalData] = useState([]);

    const toggleLoading = () => setLoading(prevState => !prevState)

    const fetchData = useCallback((pageNumber = 1, pageSize = 10) => {
        toggleLoading()
        serverRequest('GET', `statements?statementType=COMPANY_STATEMENT&pageNum=${pageNumber - 1}&pageSize=${pageSize}`).then(result =>{
            if (result){
                toggleLoading()
                setData(result?.data?.content);
                setOriginalData(result?.data?.content);
                setPagination(prev => ({ ...prev, current: pageNumber, pageSize, total: result?.data?.totalElements }));
            }
        }).catch(error =>{
            toggleLoading()
            console.error(error)
        })
    }, [])

    useEffect(() =>{
        fetchData()
    }, [fetchData]) // Include fetchData as dependency

    const handleTableChange = (pagination) => {
        fetchData(pagination.current, pagination.pageSize);
    };

    const handleSearch = (e) => {
        const value = e.target.value.toLowerCase();
        setSearchText(value);

        const filteredData = originalData.filter(item =>
            Object.values(item).some(val =>
                String(val).toLowerCase().includes(value)
            )
        );
        setData(filteredData);
    };

    const exportFunction = (type) => {
        serverRequest('GET', 'statements/all?statementType=COMPANY_STATEMENT').then(result => {
            if (result){
                if (type === 'pdf'){
                    exportToPDF(columns, result.data, 'Company Statement',true)
                }else{
                    exportToCSV(result.data, 'Company Statement')
                }
            }
        })

    }

    return (
        <div className="p-4">
            <Space style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between' }}>
                 <div>
                    <p className="lead">Company Statement</p>
                </div>
                <Space>
                    <Navigate path='/dashboard/statements/generation' state={{ type: 'company' }}>
                        <button className='btn btn-primary'>Generate</button>
                    </Navigate>
                    <div className="dropdown">
                        <Button icon={<DownloadOutlined />} className='dropdown-toggle' id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">EXPORT</Button>
                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                            <li><button className="dropdown-item" type="button" onClick={() => exportFunction('csv')}>Export to CSV</button></li>
                            <li><button className="dropdown-item" type="button" onClick={() => exportFunction('pdf')}>Export to PDF</button></li>
                        </ul>
                    </div>
                    <Input
                        prefix={<SearchOutlined />}
                        placeholder="SEARCH"
                        style={{ width: 200 }}
                        value={searchText}
                        onChange={handleSearch}
                        allowClear
                    />
                </Space>
            </Space>
            <Table
                columns={columns} dataSource={data} rowKey={(record) => record.createdAt} pagination={pagination} loading={loading} onChange={handleTableChange} />
        </div>
    );
};

export default CompanyStatementTable;